/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { createEntityAdapter } from '@reduxjs/toolkit';

import { ParsedOpenAPIExtension } from '../../../../ts/extensions';

// Entity Adapter
// use id/entity for parsedOpenAPIExtensions
// note leave sortComparer undefined, fine that it leaves array unsorted
// We key off of the channel instance id here as if OpenAPI custom extensions get moved to being defined at the instance level,
// we may lose our 1:1 mapping of each catalog item to a channel instance.
export const instancesAdapter = createEntityAdapter<ParsedOpenAPIExtension>({
  selectId: t => t.integration_id
});
